import { z } from 'zod';

export const getEngineerDataResponseSchema = z.object({
  name: z.string(),
  lastName: z.string(),
  street: z.string(),
  houseNumber: z.string(),
  flatNumber: z.string(),
  postalCode: z.string(),
  city: z.string(),
  mobilePhone: z.string(),
  email: z.string(),
  licenseId: z.string(),
});

export type GetEngineerDataResponse = z.infer<typeof getEngineerDataResponseSchema>;
